import { render, staticRenderFns } from "./GQLDelete.vue?vue&type=template&id=5df04d9b"
import script from "./GQLDelete.vue?vue&type=script&lang=js"
export * from "./GQLDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports